export const FIRST_ADVERTISEMENT_INDEX = 'red_admin_first_advertisement_index'
export const JOB_REFER_DRAFT = 'red_admin_job_refer_draft'
export const AUTH_TOKEN = 'red_admin_auth_token'
export const LOCAL_STORAGE_BANNER_STATUS = 'red_admin_banner_status'
export const SIDE_NAV_OPEN = 'red_admin_side_nav_open'
export const KEEP_CANDIDATE_FILTER_OPEN = 'red_admin_keep_candidate_filter_open'

export type LocalStorageBannerStatus = {
  [key: number]: string // キーはバナーID、値はバナーの最終表示日
}
// AI課題フィードバックの担当者情報(名前・肩書き・経歴)。次回記入時の自動入力に使う
export const ASSIGNMENT_FEEDBACK_STAFF = 'red_admin_assignment_feedback_staff'
// スカウトフォームで最後に選択したスカウトタイプ(フォーム形式 / フリー形式)。次回表示時の初期値に使う
export const SCOUT_TYPE = 'red_admin_scout_type'
